<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
<!--          <img class="d-block mx-auto mb-4" src="/img/404.png" />-->
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
<!--            <h4 class="pt-3">{{$t('shared.OopsYouAreLost')}}</h4>-->
<!--            <p class="text-muted">{{$t('shared.ThePageYouAreLookingForWasNotFound')}}</p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
